module.exports = __webpack_public_path__ + "fonts/Roboto-ThinItalic.7384da64.ttf";